import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL = "/folks_logo.png";

const links = [
  { to: "/about", label: "About" },
  { to: "/vision", label: "Vision" },
  { to: "/future", label: "Future" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: scrolled ? "rgba(247,247,247,0.85)" : "transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        borderBottom: scrolled ? "1px solid var(--soft-border)" : "1px solid transparent",
        transition: "all 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
      }}
    >
      <div className="container-wide flex items-center justify-between" style={{ height: 168 }}>
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Folks Foundation"
            style={{
              height: 128,
              width: "auto",
              objectFit: "contain",
            }}
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-mono text-[11px] tracking-[0.22em] uppercase link-underline ${
                  isActive ? "text-[color:var(--mulberry)]" : "text-[color:var(--charcoal)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden border-t border-[color:var(--soft-border)]"
          style={{ background: "var(--pearl)" }}
        >
          <div className="container-wide py-8 flex flex-col gap-6">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="font-display text-3xl font-bold tracking-tight"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
